module.exports = __webpack_public_path__ + "static/media/leaderboard-individuals.e049b2b1.svg";